module.exports = __webpack_public_path__ + "static/img/1.35d9104.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Iverland/1.jpg
// module id = BfIE
// module chunks = 0